module.exports = __webpack_public_path__ + "assets/images/logo-leaf.2ba7da97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-leaf.svg
// module id = 341
// module chunks = 1